import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import MoaStyledComponent from "../../Style/MoaStyled";
import { ResponsiveScatterPlot, } from "@nivo/scatterplot";
var StyledComponent = styled(function (props) {
    var data = props.data, width = props.width, height = props.height, margin = props.margin, xScale = props.xScale, xFormat = props.xFormat, yScale = props.yScale, yFormat = props.yFormat, axisTop = props.axisTop, axisRight = props.axisRight, axisLeft = props.axisLeft, axisBottom = props.axisBottom, legends = props.legends, legendsDefault = props.legendsDefault, nodeSize = props.nodeSize;
    return (_jsx("div", { style: {
            width: width || 500,
            height: height || 500,
        }, children: _jsx(ResponsiveScatterPlot, { data: data, margin: margin !== null && margin !== void 0 ? margin : { top: 50, right: 50, bottom: 50, left: 50 }, xScale: xScale !== null && xScale !== void 0 ? xScale : { type: 'linear', min: 0, max: 'auto' }, xFormat: xFormat !== null && xFormat !== void 0 ? xFormat : ">-.2f", yScale: yScale !== null && yScale !== void 0 ? yScale : { type: 'linear', min: 0, max: 'auto' }, yFormat: yFormat !== null && yFormat !== void 0 ? yFormat : ">-.2f", blendMode: "multiply", axisTop: axisTop !== null && axisTop !== void 0 ? axisTop : null, axisRight: axisRight !== null && axisRight !== void 0 ? axisRight : null, axisLeft: axisLeft !== null && axisLeft !== void 0 ? axisLeft : {
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "y",
                legendPosition: "middle",
                legendOffset: -60,
                truncateTickAt: 0,
            }, axisBottom: axisBottom !== null && axisBottom !== void 0 ? axisBottom : {
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "x",
                legendPosition: "middle",
                legendOffset: 46,
                truncateTickAt: 0,
            }, legends: legends ? legends : legendsDefault ? [
                {
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 130,
                    translateY: 0,
                    itemWidth: 100,
                    itemHeight: 12,
                    itemsSpacing: 5,
                    itemDirection: "left-to-right",
                    symbolSize: 12,
                    symbolShape: "circle",
                    effects: [
                        {
                            on: "hover",
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ] : undefined, nodeSize: nodeSize !== null && nodeSize !== void 0 ? nodeSize : undefined }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
